import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { FooterModal } from "./common/modal/Footer";
import CustomSelect from "./common/CustomSelect";
import SearchComponent from "./common/Search";
import RadioButton from "./common/RadioButton";
import { Body } from "./common/modal/Body";
import { HeaderModal } from "./common/modal/Header";
import { Modal } from "./common/modal/Modal";
import useAppState from "../context/useAppState";
import { findSelectedOption } from "../utils/function";
import LeavePlanner from "./common/modal/LeavePlanner";
import { useDebounce } from "hooks/common/useDebounce";
import { getEventInviteRoles } from "services/board";

import transferIcon from "../assets/images/transfer-owership-icon.svg";
import { optionProp } from "types";
import allImgPaths from "assets/images";


const FeteSettingModal = (props: any) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { isShowSettingModal, setIsShowSettingModal } = props;
  const [error, setError] = useState<string | null>(null);
  const [selectedValueOfRemoveUser, setSelectedValueOfRemoveUser] = useState<optionProp | null>(null);

  const userData: string | null = localStorage.getItem('userData')
  let userId: any = null;

  if (userData) {
    userId = JSON.parse(userData).id;
  }

  const {
    selectedFeteAccess,
    feteAccessOptions,
    eventPlanners,
    searchQuery,
    handleChangeRole,
    currentEventId,
    handleRemove,
    handleSubmit,
    handleOptionChange,
    handleInputChange,
    fetchFeteAccessOptions,
    fetchCollaborators,
    selectedRemoveUser,
    showLeavePlanner,
    showRemoveUserModal,
    currentUserId,
    showTransferModal,
    initialEventPlanners,
    setState,
    roles
  } = useAppState("boardData");

  const { updateEventCallApiFlag } = useAppState("eventData");

  const useDebounceTerm = useDebounce(searchQuery);
  useEffect(() => {
    fetchCollaborators(id)
  }, [useDebounceTerm])
  
  const clearStateAndCloseModal = async (isSaveBtnClick: Boolean) => {
    if(isSaveBtnClick){
      handleSubmit(id);
      updateEventCallApiFlag(true)
    }
    setIsShowSettingModal(false);
    setState({ searchQuery: '', selectedFeteAccess: '', eventPlanners: initialEventPlanners })
  }
  
  useEffect(() => {
    if(isShowSettingModal){
      fetchCollaborators(id);
      fetchFeteAccessOptions(id);
    }
  }, [isShowSettingModal]);

  useEffect(() => {
    if(id && currentEventId === ''){
      setState({ currentEventId: id})
    }
  },[currentEventId])

  useEffect(() => {
    if (roles && roles.length === 0) {
      (async () => {
        const { data }  = await getEventInviteRoles();
        setState({ roles: data.map((role: any) => {
          return {
            label: role.name,
            value: role.name,
            id: role._id
          }
        }) })
      })()
    }
  },[roles])

  // const handleCloseModal = () => {
  //   setState({ showLeavePlanner: false, showRemoveUserModal: false, showTransferModal: false, selectedName: null, selectedUser: null });
  //   setError(null);
  //   setSelectedValueOfRemoveUser(null);
  // }

  // console.log('feteAccessOptions', feteAccessOptions);

  return (
    <>
      {/* Modal */}
      <Modal
        className={"modal-wrapper max-w-[480px]"}
        isShow={isShowSettingModal}
      >
        <form onSubmit={handleSubmit}>
          <HeaderModal
            title="Fete Settings"
            isShowHeader={true}
            className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
          >
            <div className="flex items-center justify-between">
              <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                Fete Settings
              </h2>
              {/* Close Icon */}
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                id="modal-toggle"
                src={allImgPaths.closeIcon}
                onClick={() => clearStateAndCloseModal(false)}
                alt="close icon"
              />
            </div>

            <p className="text-sm text-[#475467]">
              Manage your fete privacy and planners
            </p>
          </HeaderModal>

          <Body title="" isShowBody={true} className="modal-body pl-6 pr-5 pt-5 max-h-[calc(100vh_-_448px)] overflow-y-scroll scrollbar-adjust">
            <div className="mb-6">
              <p className="text-sm text-[#344054] font-interMedium pb-2">
                Fete Access
              </p>
                <RadioButton
                  options={feteAccessOptions}
                  selectedOption={selectedFeteAccess}
                  onOptionChange={handleOptionChange}
                />
            </div>

            <div className="flex justify-between items-center mb-3">
              <p className="text-[#344054] text-sm font-interMedium">
                Manage Planners
              </p>
              <div className="border border-[#D0D5DD] flex rounded-lg py-1 px-3.5 gap-x-2 w-[180px] hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                <img src={allImgPaths.searchIcon} alt="search icon" />
                <SearchComponent
                  onChange={handleInputChange}
                  value={searchQuery}
                />
              </div>
            </div>

            <div className="mb-4">
              {eventPlanners.length > 0 ?
                eventPlanners.map((member: any, index: number) => (
                  <div className="" key={index}>
                    <div className="flex mb-2">
                      <div className="flex w-[50%]">
                        <img
                          className="w-10 h-10 rounded-full mr-3 border border-[#ccc]"
                          src={allImgPaths.defaultProfileImage}
                          alt=""
                        />
                        <div className="">
                          <h6 className="text-[#101828] text-sm font-interSemiBold">
                            {member.name}
                          </h6>
                          <p title={member.email} className="text-sm text-[#475467] truncate max-w-40">
                            {member.email}
                          </p>
                        </div>
                      </div>

                      <div className="w-[25%] modal-select-box">
                        {member.user_id !== currentUserId ? (
                          <CustomSelect
                            key={index}
                            selectedValue={
                              member.teams.roleName
                                ? findSelectedOption(roles,member.teams.roleName)
                                : null
                            }
                            options={roles}
                            onChange={(selectedRole) =>
                              handleChangeRole(index, selectedRole)
                            }
                            extendedOption={false}
                            menuPlacement={'top'}
                            className="border border-[#ccc] rounded-lg hover:border-[#1e0af5] focus-within:border-[#1e0af5] disable-hover-on-focus"
                          />
                        ): (
                          <div className="flex items-center pl-4 h-10 text-[#475467] tex-sm font-interMedium">Owner</div>
                        )}
                      </div>

                      <div
                        className="flex items-center gap-x-4 justify-end w-[25%] -mt-1.5"
                      >
                       
                        {
                          // matching member array with loggedIn user
                          member.user_id === userId
                            ?
                            <>
                              <img
                                className="cursor-pointer w-6 h-6 hover:bg-[#f2f4f7] rounded p-0.5"
                                src={allImgPaths.RefreshIcon} alt="refresh" title="transfer"
                                onClick={() => setState({ showTransferModal: true })} />
                              <img className="cursor-pointer w-6 h-6 hover:bg-[#FEE4E2] rounded p-0.5" src={allImgPaths.removeUserIcon} title="leave" alt="remove" onClick={() => setState({ showLeavePlanner: true })} />
                            </> :
                            <img
                              className="cursor-pointer w-6 h-6 hover:bg-[#FEF3F2] rounded p-0.5"
                              src={allImgPaths.removeUserIcon2}
                              alt="remove"
							  title="remove"
                              onClick={() => handleRemove(member, index)}
                            />
                        }
                      </div>
                    </div>
                  </div>
                )) : (
                  <span className="text-sm text-[#D92D20]">User not found</span>
                )}
            </div>
          </Body>

          <FooterModal
            title=""
            isShowFooter={true}
            className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]"
          >
            <div className="flex items-center gap-x-3 justify-center">
              <button
                className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 hover:bg-[#f2f4f7]"
                onClick={() => clearStateAndCloseModal(false)}
              >
                Cancel
              </button>
              <button className="!text-base text-white bg-[#1E0AF5] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1 hover:bg-[#120693]"
                onClick={() => clearStateAndCloseModal(true)}
              >
                Save
              </button>
            </div>
          </FooterModal>
        </form>
        {/* Leave Planner and user modal */}
        <LeavePlanner
          isShow={showLeavePlanner}
          title={t('settings.leaveModalText.leavePlannerText.title')}
          subTitle={t('settings.leaveModalText.leavePlannerText.subtitle')}
          dropDownLabel="Select planner"
          icon={allImgPaths.leaveFeteIcon}
          actionType="leavePlanner"
          onCloseModal={() => { setState({ showLeavePlanner: false, selectedName: null, selectedUser: null }); setError(null) }}
          onSubmit={onsubmit}
          error={error}
          setError={setError}
          btnText="Leave"
        />
        <LeavePlanner
          isShow={showRemoveUserModal}
          title={t('settings.leaveModalText.removeUserText.title')}
          subTitle={t('settings.leaveModalText.removeUserText.subtitle')}
          dropDownLabel="Select planner"
          icon={allImgPaths.RemoveUserIcon3}
          actionType="removeUser"
          onCloseModal={() => { setState({ showRemoveUserModal: false,selectedRemoveUser:null, selectedName: null, selectedUser: null }); setError(null) }}
          setSelectedValueOfRemoveUser={setSelectedValueOfRemoveUser}
          error={error}
          setError={setError}
          btnText="Remove user"
        />
        <LeavePlanner
          isShow={showTransferModal}
          title={t('settings.leaveModalText.transferUser.title')}
          subTitle={t('settings.leaveModalText.transferUser.subtitle')}
          dropDownLabel="Select team member"
          icon={transferIcon}
          actionType="transferUser"
          onCloseModal={() => { setState({ showTransferModal: false, selectedName: null, selectedUser: null }); setError(null) }}
          error={error}
          setError={setError}
          btnText="Transfer"
          setIsShowSettingModal={setIsShowSettingModal}
        />
      </Modal>
    </>
  );
};

export default FeteSettingModal;
